// src/Components/GenericComponent/ConfirmAlert.jsx
import * as React from "react";
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
export const ConfirmAlert = ({ open, onConfirm, onCancel, name }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} modalType="alert" onOpenChange={onCancel}>
      <DialogSurface >
        <DialogBody>
          <DialogTitle>{t("CONFIRMATION_TITLE")}</DialogTitle>
          <DialogContent>
          {t("CONFIRMATION_MESSAGE")} <strong>{name}</strong> ?
          </DialogContent>
          <DialogActions>
            <Button  appearance="primary" onClick={onConfirm}>
            {t("DELETE")}
            </Button>
            <Button appearance="secondary" onClick={onCancel}>
            {t("CANCEL")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
